// Cave84 — Appellations service (Phase 1 Week 3)
// Read-only from UI perspective (seeded via import). Owner can add manually.

import {
  addDoc, doc, getDoc, getDocs, orderBy, query, serverTimestamp
} from 'firebase/firestore';
import type { Appellation } from '@cave84/shared-types';
import { db } from './firebase';
import { typedCollection } from './firestore';

const COLLECTION = 'appellations';

export type AppellationCreateInput = Omit<Appellation, 'id' | 'usage_count'>;

function col() { return typedCollection<Appellation>(COLLECTION); }

export async function listAppellations(): Promise<Appellation[]> {
  const snap = await getDocs(query(col(), orderBy('name', 'asc')));
  return snap.docs.map(d => d.data());
}

export async function getAppellation(id: string): Promise<Appellation | null> {
  const snap = await getDoc(doc(db, COLLECTION, id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...(snap.data() as Omit<Appellation, 'id'>) };
}

export async function createAppellation(input: AppellationCreateInput): Promise<Appellation> {
  const payload = { ...input, usage_count: 0, created_at: serverTimestamp() };
  const ref = await addDoc(col(), payload as unknown as Appellation);
  return { id: ref.id, usage_count: 0, ...input };
}
